import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IoArrowUpCircleOutline } from "react-icons/io5";

import RoomImg from "../Images/Resized/Room/Delux_Room.webp";
import Back2 from "../Images/JCPIC/10.jpg";
import Room from "../Images/Resized/Room/Executive_Room.webp";
import Room2 from "../Images/Resized/Room/Suite_Room.webp";

import { Lawn, BanquetHall, Confresshall } from "./importImages.js";

import NoticeCard from "./RoomCencletion";
import BookingFormSelector from "./BookingFormSelector";

export default function Accommodation() {
  const { type } = useParams();
  const navigate = useNavigate();

  const memberID = sessionStorage.getItem("MemberID");

  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [adult, setAdult] = useState("");
  const [children, setChildren] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [memberName, setMemberName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [guestName, setGuestName] = useState("");
  const [email, setEmail] = useState("");
  const [isSelf, setIsSelf] = useState(false);

  useEffect(() => {
    scrollToTop();
  }, [type]);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const facilityData = {
    Room: {
      title: "Room & Suites",
      type: "Room",
      description: "Explore our premium single, family and presidential rooms.",
      images: [RoomImg, Room, Room2],

    },
    Lawn: {
      title: "Lawn Booking",
      type: "Lawn",
      description: "Perfect green space for outdoor events and parties.",
      images: Lawn,

    },
    BanquetHall: {
      title: "Banquet Hall",
      type: "BanquetHall",
      description: "Ideal for weddings and large gatherings.",
      images: Confresshall,

    },
  };

  const facility = facilityData[type] || facilityData["Room"];
  const slides = Array.isArray(facility.images) ? facility.images.slice(0, 5) : [];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides]);

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    if (!memberName || !checkIn || !checkOut) {
      alert("Please fill in all required booking details.");
      return;
    }
    alert(`Booking requested by ${memberName} for ${facility.title}`);
    setShowModal(false);
  };

  return (
    <div>
    {/* Back Button (hidden on mobile) */}
<div
  style={{
    position: "absolute",
    top: "15px",
    left: "15px",
    zIndex: 1100,
  }}
  className="d-none d-md-block" // ✅ Bootstrap utility: hidden on xs/sm, visible md+
>
  <button
    onClick={() => navigate(-1)}
    className="btn btn-danger"
    style={{ padding: "6px 12px", fontWeight: "bold" }}
  >
    &larr; Back
  </button>
</div>


      {/* Hero Banner */}
      <div
        className="hero-banner"
        style={{
          backgroundImage: `url(${Back2})`,
          height: "300px",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
      </div>

      {/* Booking Form */}
      <br/>
      <BookingFormSelector  facilityType={facility.type} />

      {/* Facility Section */}
      <div className="container">

        <div className="row">
          {/* {facility.categories.map(({ img, roomCat, price }, idx) => (
            <div
              key={idx}
              className="col-md-4 mb-4"
              style={{
                cursor: "pointer",
                borderRadius: "15px",
              }}
            >
              <div className="card rounded-5">
                <img
                  src={img}
                  alt={roomCat}
                  className="card-img-top"
                  style={{
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                    height: "180px",
                    objectFit: "cover",
                  }}
                />
                <div className="card-body">
                  <h5 className="card-title text-danger">{roomCat}</h5>
                  {price > 0 && <p className="card-text">₹ {price} / day</p>}
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>

      {/* Scroll To Top Button */}
      <button
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          backgroundColor: "red",
          borderRadius: "50%",
          border: "none",
          padding: "10px",
          color: "white",
          fontSize: "24px",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        <IoArrowUpCircleOutline />
      </button>

      {/* Image Carousel */}
      <section className="">
        <div className="text-center mb-4">
          {type === "Lawn" ? (
            <></>
          ) : (
            <>
            </>
          )}
        </div>

        <div className="mx-auto" style={{ width: "90%" }}>
          {slides.length === 0 ? (
            <p className="text-center">No images available.</p>
          ) : (
            <>
              {slides.map((slide, index) => (
                <div key={index} style={{ display: index === activeSlide ? "block" : "none" }}>
                  <img
                    src={slide}
                    className="img-fluid rounded w-100"
                    alt={`Slide ${index + 1}`}
                    style={{ height: "400px", objectFit: "cover" }}
                  />
                </div>
              ))}
              <div className="d-flex justify-content-center mt-3">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveSlide(index)}
                    className={`slider-dot ${index === activeSlide ? "active" : ""}`}
                    style={{
                      width: "12px",
                      height: "12px",
                      margin: "0 6px",
                      borderRadius: "50%",
                      border: "none",
                      backgroundColor: index === activeSlide ? "#dc143c" : "#ccc",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      <NoticeCard />
    </div>
  );
}
